import React, { type FC } from 'react';
import css from './markdowns.scss';
import {
  SectionHelper,
  type SectionHelperAppearance,
  Text,
} from '@wix/design-system';
import { DataHooks } from '../../constants/dataHooks';

export const blockquoteAppearances: SectionHelperAppearance[] = [
  'warning',
  'standard',
  'success',
];

type BlockquoteAppearances = (typeof blockquoteAppearances)[number];

type Props = {
  content: string;
  className: BlockquoteAppearances;
};

export const Blockquote: FC<Props> = ({ content, className }) => {
  const appearance = getSectionHelperAppearance(className);
  return (
    <blockquote className={css.blockquote}>
      <SectionHelper
        dataHook={DataHooks.BlockquoteSectionHelper}
        appearance={appearance}
        fullWidth
      >
        <Text
          dataHook={DataHooks.BlockquoteTextContent}
          size="small"
          weight="thin"
        >
          {content}
        </Text>
      </SectionHelper>
    </blockquote>
  );
};

const getSectionHelperAppearance = (
  className: BlockquoteAppearances,
): SectionHelperAppearance =>
  blockquoteAppearances.includes(className) ? className : 'standard';
